module.exports = __webpack_public_path__ + "static/media/dormitorio-principal.dfde515f.jpg";